import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BackendApiService } from '../backend-api.service';

@Injectable({
  providedIn: 'root'
})
export class StaffService {

  constructor(
    private backendApiService: BackendApiService,
  ) { }

  processStaff(staff: any, includeInActiveList: any = []){
    return staff
      .filter((staff : any) => staff.is_terminate != 1 || includeInActiveList.includes(staff.id))
      .map((staff:any)=>{
        if (staff.is_terminate == 1){
          staff.full_name =  `${staff.full_name} (In Active)`;
          // staff.disabled =  true;
        }
        return staff;
      });
  }

  getStaffById(staff: any, id: any){
    return staff.find((x: any) => x.id == id)
  }

  searchStaff(params: any): Observable<any> {
    return this.backendApiService.getApi('staff', params);
  }
}
